import React from 'react';

import styles from './styles.module.css';
import { FeeCharge } from './types';
import classNames from 'classnames';
import { chargeValue } from './utils';

const generateDataTestId = (label: string) =>
  `fee-line-${label.toLowerCase().replace(/\s+/g, '-')}`;

function chargeDisplay(charge: FeeCharge): string {
  return charge.type === 'FLAT' ? `$${charge.amount}` : `${charge.percent}%`;
}

export type FeeChargeProps = {
  charge: FeeCharge;
  maxCharge: FeeCharge;
};

export const FeeChargeDisplay: React.FC<FeeChargeProps> = ({
  charge,
  maxCharge,
}) => {
  if (chargeValue(charge) === chargeValue(maxCharge)) {
    return (
      <span className={styles.feeLineChargeWorse}>{chargeDisplay(charge)}</span>
    );
  } else {
    return (
      <div className={styles.feeLineChargeComparison}>
        <span className={styles.feeLineChargeBetter}>
          {chargeDisplay(charge)}
        </span>
        <span className={styles.feeLineMaxCharge}>
          {chargeDisplay(maxCharge)}
        </span>
      </div>
    );
  }
};

export type FeeLineProps = {
  fee: {
    displayName: string;
    charge: FeeCharge;
    maxCharge: FeeCharge;
  };
};

export const FeeLine: React.FC<FeeLineProps> = ({ fee }) => (
  <div
    data-testid={generateDataTestId(fee.displayName)}
    className={styles.feeLineContainer}
  >
    <span className={styles.feeLineLabel}>{fee.displayName}</span>

    <span
      className={classNames(styles.feeLineValueContainer, styles.feeLineValue)}
    >
      <FeeChargeDisplay charge={fee.charge} maxCharge={fee.maxCharge} />
    </span>
  </div>
);
